/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { CSSObjectWithLabel } from 'react-select';

import { gridSize, colors } from '@atlaskit/theme';
import { media } from '@atlassian/bitkit-responsive';

import { overflowEllipsis } from 'src/styles/mixins';

export const PLACEHOLDER_COLOR = colors.N400;

export type StateProps = {
  isFocused: boolean;
};

export const subtleSelector = (css: CSSObjectWithLabel, state: StateProps) => ({
  backgroundColor: state.isFocused ? css.backgroundColor : 'transparent',
  borderColor: state.isFocused ? css.borderColor : 'transparent',
});

export const nothingSelectedColor = () => ({
  color: colors.N400,
});

export const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  /* Atlaskit overrides to fit our filter styles */
  > button {
    height: ${gridSize() * 5}px;
  }

  > * + * {
    margin: 0 ${gridSize() / 2}px;
  }

  > :last-child {
    margin-right: 0;
  }

  ${media.upToMedium(`
    justify-content: flex-start;

    > * + * {
      margin: ${gridSize()}px;
    }
  `)}

  ${media.upToSmall(`
    > * + * {
      margin: ${gridSize()}px 0;
    }
  `)}
`;

export const BranchSelectorWrapper = styled.div`
  margin: 0 ${gridSize()}px 0 ${gridSize() * 2}px;

  ${media.upToMedium(`
    margin: ${gridSize()}px ${gridSize()}px ${gridSize()}px 0;
  `)}
`;

export const SortSelectorWrapper = styled.div`
  margin-left: auto;
  min-width: ${gridSize() * 24}px;
`;

export const Filter = styled.div<{
  mobileOrder?: number;
  isFirstFilterElement?: boolean;
}>`
  margin-left: ${({ isFirstFilterElement }) =>
    isFirstFilterElement ? `${gridSize() * 2}px` : `${gridSize() / 2}px`};

  ${media.upToMedium(`
    margin-left: 0;
  `)}

  ${media.upToSmall(`
    order: ${({ mobileOrder }: { mobileOrder?: number }) => mobileOrder || 1};
  `)}
`;

export const Ellipsis = styled.div`
  ${overflowEllipsis('100%')};
`;
